/**
 * 分拣组类型 Tag 配色（与项目基础配置详情「分拣组」一致）
 */
export function getSortingGroupTypeTagColor(groupType: string | null | undefined): string {
  const t = String(groupType ?? '').toLowerCase();
  switch (t) {
    case 'loose':
      return 'green';
    case 'box':
      return 'orange';
    case 'pallet':
      return 'purple';
    case 'abnormal':
      return 'red';
    case 'non_product':
      return 'gray';
    case 'ungrouped':
      return 'volcano';
    default:
      return 'blue';
  }
}

export type SortingGroupSummaryLike = {
  total_groups: number;
  loose_groups?: number;
  box_groups?: number;
  pallet_groups?: number;
  abnormal_groups?: number;
  non_product_groups?: number;
  ungrouped_groups?: number;
};

/** 与项目基础配置详情页「分拣组」短文案一致 */
export type SortingGroupBreakdownItem = {
  groupType: string;
  label: string;
  count: number;
};

/** 各类型分拣组数量，仅保留 count > 0（用于列表弹窗等） */
export function getSortingGroupBreakdownPositive(summary: SortingGroupSummaryLike): SortingGroupBreakdownItem[] {
  const s = summary;
  const items: SortingGroupBreakdownItem[] = [
    { groupType: 'loose', label: '散货库存单元分拣组', count: s.loose_groups ?? 0 },
    { groupType: 'box', label: '箱库存单元分拣组', count: s.box_groups ?? 0 },
    { groupType: 'pallet', label: '托盘库存单元分拣组', count: s.pallet_groups ?? 0 },
    { groupType: 'abnormal', label: '异常库存单元分拣组', count: s.abnormal_groups ?? 0 },
    { groupType: 'non_product', label: '非产品库存单元分拣组', count: s.non_product_groups ?? 0 },
    { groupType: 'ungrouped', label: '未分组库存单元分拣组', count: s.ungrouped_groups ?? 0 },
  ];
  return items.filter((i) => i.count > 0);
}
